import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Menschen',
    financial_metrics: 'Finanzkennzahlen',
    onboarding_and_quality: 'Einführung & Qualität',
    subscriptions: 'Aktuelle Abonnements',
    payments: 'Zahlungen',
    last_invoices: 'Letzte Rechnungen',
  },
  fields: {
    google_profile: 'Google profile',
    owner_name: 'Name des Eigentümers',
    owner_phone_number: 'Telefonnummer des Eigentümers',
    company_phone_number: 'Telefonnummer des Restaurants',
    address: 'Adresse',
    onboarding_manager: 'Onboarding-Manager',
    sales_manager: 'Vertriebsleiter',
    last_30_days_sales: 'Umsatz der letzten 30 Tage',
    lifetime_sales: 'Gesamtumsatz über die gesamte Lebensdauer',
    monthly_sales_other_platforms: 'Umsatz über Liefer-Apps',
    delivery_app_sales_at_go_live: 'Umsatz über Liefer-Apps zum Go-live',
    last_payout: 'Letzte Auszahlung',
    potential_tier: 'Potenzielle Punktzahl',
    current_tier: 'IST-Punktzahl',
    signed_at: 'Abschlussdatum',
    live_from: 'Startdatum',
    onboarding_quality_score: 'Qualitätspunktzahl zum Start',
    is_google_business_available: 'Google Business verfügbar',
    is_smart_pricing_configured: 'Günstigere Preise als Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Werbeflyer versandt',
    is_menu_fully_configured: 'Alle Menüpunkte verfügbar',
    has_offers_on_competitor_platforms:
      'Bietet das Restaurant Angebote auf Wolt, Uber, Lieferando an (außer kostenloser Lieferung)?',
    is_instagram_story_shared: 'Instagram-Story mit dem Eigentümer geteilt',
    is_order_system_connected_to_website:
      'Foodamigos-Website verbunden ODER Restaurant-eigene Website Online-Bestellbutton hinzugefügt',
    delivery_mode: 'Fahrer',
    has_storefront: '{{provider}}-Website',
    screening_date: 'Screening-Datum',
  },
  setup_fee: {
    title: 'Implementierungsgebühr',
    status: {
      [InvoiceStatus.Paid]: 'Bezahlt',
      [InvoiceStatus.Pending]: 'Ausstehend',
      [InvoiceStatus.Processing]: 'Verarbeitung',
      [InvoiceStatus.Refunded]: 'Rückerstattet',
      [InvoiceStatus.PartiallyRefunded]: 'Teilweise erstattet',
      [InvoiceStatus.Failed]: 'Fehlgeschlagen',
    },
  },
  labels: {
    yes: 'Ja',
    no: 'Nein',
    month: 'Monat',
    recorded_on: 'Erfasst am {{date}}',
  },
  delivery_app_sales_correction: {
    title: 'Umsatz über Liefer-Apps zum Go-live korrigieren',
    description:
      'Korrigiere hier nur einen Tippfehler. Das ist der monatliche Wert, den das Onboarding beim Go-live erfasst hat, und das Reporting vergleicht ihn mit dem Wert aus dem Vertrieb. Die Änderung wird protokolliert.',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Aktiv',
    [CompanyOperationalStatus.Paused]: 'Angehalten',
    [CompanyOperationalStatus.Suspended]: 'Aufgewühlt',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Monatlich',
    [SubscriptionTerm.Annual]: 'Jährlich',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Eigene Fahrer',
    [DeliveryMode.External]: '{{provider}}-Treiber',
  },
  buttons: {
    view_details: 'Details anzeigen',
    open: 'Öffnen',
    correct: 'Korrigieren',
    save: 'Speichern',
    cancel: 'Abbrechen',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    delivery_app_sales_corrected: 'Umsatz über Liefer-Apps korrigiert',
    failed_to_correct_delivery_app_sales: 'Umsatz über Liefer-Apps konnte nicht korrigiert werden',
  },
};
